// extracted by mini-css-extract-plugin
var _1 = "FacetDropdown-module__emptyMessage--yIuT6";
export { _1 as "emptyMessage" }
